import { LitElement, css, unsafeCSS } from 'lit';
import lighningCss from '@salesforce-ux/design-system/assets/styles/salesforce-lightning-design-system-offline.min.css?inline';
export class GGOBaseComponent extends LitElement {
    static { this.properties = {}; }
    static get styles() {
        const host_styles = css ``;
        return [unsafeCSS(lighningCss), host_styles];
    }
    constructor() {
        super();
    }
    static createElement(tag, event, attributes, text) {
        const el = document.createElement(tag);
        if (attributes)
            Object.entries(attributes).forEach(([key, value]) => el.setAttribute(key, value));
        if (text)
            el.textContent = text;
        if (event)
            el.addEventListener(event.type, event.listener);
        return el;
    }
}
